import React from 'react';
import Icon from '../../../components/AppIcon';

const CapabilitiesMatrix = ({ service }) => {
  const getExpertiseColor = (level) => {
    switch (level) {
      case 'Expert': return 'text-success bg-success/10';
      case 'Advanced': return 'text-primary bg-primary/10';
      case 'Intermediate': return 'text-warning bg-warning/10';
      default: return 'text-muted-foreground bg-muted';
    }
  };

  const getExpertiseIcon = (level) => {
    switch (level) {
      case 'Expert': return 'Award';
      case 'Advanced': return 'Star';
      case 'Intermediate': return 'Circle';
      default: return 'Minus';
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-soft border border-border p-8">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 rounded-full gradient-primary flex items-center justify-center">
          <Icon name="Target" size={20} color="white" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">
            Capabilities Matrix
          </h3>
          <p className="text-sm text-muted-foreground">
            Our technical competencies and experience levels
          </p>
        </div>
      </div>

      <div className="space-y-6">
        {service.capabilities.map((category, index) => (
          <div key={index} className="border border-border rounded-lg p-6">
            <h4 className="font-semibold text-foreground mb-4 flex items-center space-x-2">
              <Icon name={category.icon} size={18} className="text-primary" />
              <span>{category.name}</span>
            </h4>
            
            <div className="grid gap-4">
              {category.skills.map((skill, skillIndex) => (
                <div key={skillIndex} className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm font-medium text-foreground">
                        {skill.name}
                      </span>
                      <div className={`flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium ${getExpertiseColor(skill.level)}`}>
                        <Icon name={getExpertiseIcon(skill.level)} size={12} />
                        <span>{skill.level}</span>
                      </div>
                    </div>
                    
                    <div className="w-full bg-muted rounded-full h-2">
                      <div 
                        className="h-2 rounded-full gradient-primary transition-all duration-500"
                        style={{ width: `${skill.proficiency}%` }}
                      ></div>
                    </div>
                    
                    <div className="flex items-center justify-between mt-2 text-xs text-muted-foreground">
                      <span>{skill.experience}</span>
                      <span>{skill.proficiency}% proficiency</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-primary/5 rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={16} className="text-primary mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm text-foreground font-medium mb-1">
              Expertise Levels Explained
            </p>
            <div className="text-xs text-muted-foreground space-y-1">
              <div><strong>Expert:</strong> 5+ years, leading complex projects</div>
              <div><strong>Advanced:</strong> 3-5 years, independent execution</div>
              <div><strong>Intermediate:</strong> 1-3 years, guided implementation</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CapabilitiesMatrix;